import { withAuth } from '@okta/okta-react';
import { CrudList } from '@westernmilling/eu_react_shared';

import ItemForm from 'components/Forms/CreditRating';

export default withAuth(class CreditRatingsContainer extends CrudList {
  getColumns = () => this.sharedNameColumns(true);

  getFormTag = () => ItemForm;

  getListApi = () => 'credit/credit_ratings';

  getStorageName = () => 'otto_credit_ratings_list';

  getAddGroups = () => ['credit_admin'];

  getEditGroups = () => ['credit_admin'];

  getPageTitle = () => 'Credit Ratings';

  getAddText = () => 'Create Credit Rating';

  canDownloadCsv = () => true;

  auditLogModelType = () => 'Credit::CreditRating';
});
